
export const generalLabels = {
    next: "Weiter",
    back: "Zurück",
    submit: "Absenden",
    continue: "Weiter",
    cancel: "Abbrechen",
    close: "Schließen" 
}

export const aboutLabels = {
    title: "Über dich",
    firstName: "Vorname",
    lastName: "Nachname",
    birthdate: "Geburtsdatum",
    pronouns: "Deine Pronomen (optional)",
    email: "E-Mail-Adresse",
    phone: "Telefonnummer",
    nationality: "Nationalität",
    residency: "Wohnort",
}

export const positionLabels = {
    title: "Dein Einsatz an Bord",
    positions: "Position(en) an Bord",
    startDate: "Frühestmögliches Startdatum",
    moreInfoDate: "Nähere Informationen über deine Verfügbarkeit",
    cv: "Lebenslauf",
    motivation: "Motivation",
    motivationPlaceholder: "Schreibe mindestens drei Sätze darüber, warum du Teil unserer Crew werden möchtest.",
}

export const languagesLabels = {
    title: "Sprachkenntnisse",
    arabic: "Arabisch",
    english: "Englisch",
    french: "Französisch",
    italian: "Italienisch",
    none: "Keine",
    professional: "Professionell",
    additionalLanguages: "Weitere Sprachen (optional)",
}

export const certificatesLabels = {
    title: "Zertifikate und Lizenzen",
    basicSafety: "Sicherheitsgrundausbildung (STCW A-VI/1)",
    expiryDateBasicSafety: "Ablaufdatum Sicherheitsgrundausbildung",
    medicalCertificate: "Seediensttauglichkeitszeugnis (für Menschen mit Sicherheitsgrundausbildung)",
    expiryDateMedicalCertificate: "Ablaufdatum Seediensttauglichkeitszeugnis",
    rhibLicense: "Sportbootführerschein (SBF)",
    additionalCertificates: "Befähigungsnachweis für professionelle Seefahrer*innen und andere Zertifikate",
    additionalCertificatesPlaceholder: "Bitte führe alle zusätzlichen Zertifikate an mit der jeweiligen STCW- Referenz und dem Ablaufdatum.",
}

const skillsLabels = {
    title: "Fähigkeiten und Erfahrungen",
    relevantSkills: "Relevante Fähigkeiten",
    otherRelevantSkills: "Weitere Fähigkeiten und Erfahrungen",
    medicalBackground: "Medizinischer Hintergrund",
    medicalBackgroundPlaceholder: "Verfügst du über einen medizinischen Hintergrund (z.B. Erste-Hilfe-Kurs, Notfallsanitäter*in, Ärzt*in...)",
    dataprotection: "Ich stimme dem Speichern meiner Daten für einen Zeitraum von 6 Monaten zu.",
    relevantSkillOptions: [
        'Kochen',
        'Schweißen',
        'Logistik',
        'Übersetzen',
        'Handwerkliches Geschick',
        'Segeln',]
}


const labels = {
    general: generalLabels,
    about: aboutLabels,
    position: positionLabels,
    languages: languagesLabels,
    certificates: certificatesLabels,
    skills: skillsLabels
}

export default labels